<template>
  <v-row v-if="view" class="pa-0 ma-0">
    <v-col cols="12" class="pa-0">
      <v-card flat color="transparent">
        <v-card-text class="py-0">
          <v-row align="center" justify="center" style="height:60px;">
            <v-col cols="6" class="pa-0" align="center">
              <v-row align="center" justify="start" class="ma-0 pa-0">
                <v-col class="pa-0" align="center">
                  <v-btn :outlined="metric != 2" depressed color="primary" @click="metric = 2" class="ma-1 span"><span class="caption font-weight-bold">実績</span></v-btn>
                  <v-btn :outlined="metric != 1" depressed color="primary" @click="metric = 1" class="ma-1 span"><span class="caption font-weight-bold">目標</span></v-btn>
                </v-col>
                <v-col cols="2" class="pa-0" align="center">
                  <v-select
                    :items="$YEARS"
                    label="年度"
                    hideDetails
                    v-model.number="year"
                    class="pr-1"
                    item-text="name"
                    item-value="value"
                  ></v-select>
                </v-col>
                <v-col cols="2" class="pa-0" align="center">
                </v-col>
                <v-col cols="2" class="pa-0" align="center">
                </v-col>
                <v-col cols="2" class="pa-0" align="center">
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6" class="pa-0">
              <v-row align="center" justify="start" class="ma-0 pa-0">
                <v-col cols="10" class="pa-0" align="center">
                  <v-select
                    class="pr-1"
                    :items='tempGroups'
                    label='教室'
                    v-model='group'
                    item-text="name"
                    item-value="key"
                    multiple
                    hideDetails
                    small-chips
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <keep-alive>
            <template-plans
              v-if="metric == 1"
              :data="data"
              :year="year"
              :school="school"
              :group="group"
              :tempGroups="tempGroups"
              :pColor="'success'"
              :sColor="'#757575'"
            >
            </template-plans>
            <template-fees
              v-if="metric == 2"
              :view="view"
              :g="g"
              :m="mm"
              :data="data"
              :year="year"
              :school="school"
              :group="group"
              :tempGroups="tempGroups"
              :pColor="'lime darken-4'"
              :sColor="'#757575'"
            >
            </template-fees>
          </keep-alive>
        </v-card-text>
      </v-card>
    </v-col>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
  <v-row v-else class="ma-0" align="center">
    <v-sheet width="100%">
      <template-fees :tempGroups="tempGroups" :year="y" :view="view" :type="type" :g="g" :m="mm"></template-fees>
    </v-sheet>
  </v-row>
</template>
<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Fees from './templates/Fees'
import Plans from './templates/Plans'
Vue.component('template-fees', Fees)
Vue.component('template-plans', Plans)
export default {
  data () {
    return {
      loading: false,
      dialog: false,
      metric: 2,
      tempGroups: [],
      group: [],
      year: null,
      school: null
    }
  },
  props: ['view', 'type', 'width', 'g', 'mm', 'y'],
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      metricsActs: 'metricsActs/metrics',
      metricsPlans: 'metricsPlans/metrics',
      metricsFees: 'metricsFees/metrics',
      metricsRevises: 'metricsRevises/metrics'
    })
  },
  watch: {
    groups () {
      this.createGroups()
    }
  },
  created () {
    this.year = this.getFY()
    this.createGroups()
  },
  methods: {
    checkGroup (metric) {
      return metric.key >= 200 && metric.key < 300
    },
    createGroups () {
      this.modify = {}
      this.group = []
      this.tempGroups = []
      if (!this.data) {
        return
      }
      if (this.getPrivilegesLevel(this.data) < 2) {
        this.tempGroups.push({ name: '全校', key: '*' })
      }

      this.school = this.getPrimary()

      if (this.checkPrimary()) {
        if (this.data.order) {
          for (var i in this.data.order) {
            var index = this.groups.findIndex(group => group.key === this.data.order[i])
            if (index !== -1) {
              if (this.groups[index].enable && this.groups[index].classroom) {
                this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
              }
            }
          }
        } else {
          var keys = Object.keys(this.data.groups)
          for (i in keys) {
            if (this.data.groups[keys[i]]) {
              index = this.groups.findIndex(g => g.key === keys[i])
              if (index !== -1) {
                if (this.groups[index].enable && this.groups[index].classroom) {
                  this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
                }
              }
            }
          }
        }
        if (this.tempGroups.length !== 0) {
          if (typeof this.data.primaryGroup === 'undefined' || this.data.primaryGroup === null) {
            this.group.push(this.tempGroups[0].key)
          } else {
            for (var x in this.tempGroups) {
              if (this.tempGroups[x].key === this.data.primaryGroup) {
                this.group.push(this.data.primaryGroup)
                break
              }
            }
          }
        }
      } else {
        var school = this.getPrimary()
        if (school !== null) {
          keys = Object.keys(school.groups)
          for (i in keys) {
            if (school.groups[keys[i]]) {
              index = this.groups.findIndex(g => g.key === keys[i])
              if (index !== -1) {
                if (this.groups[index].enable && this.groups[index].classroom) {
                  this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
                }
              }
            }
          }
          if (this.tempGroups.length !== 0) {
            this.group.push(this.tempGroups[0].key)
          }
        }
      }
      for (i in this.tempGroups) {
        if (this.tempGroups[i].key !== '*') {
          Vue.set(this.modify, this.tempGroups[i].key, false)
        }
      }
    }
  }
}
</script>

<style scoped>
.v-btn.span {
  max-width: 14px !important;
  min-width: 14px !important;
  max-height: 32px !important;
}
.select-none {
  user-select: none;
}
</style>
